import { useEffect } from 'react';

import { useStore } from 'models/stores';

export default function useDocumentTitle(title = '') {
  const { companyStore } = useStore();

  useEffect(() => {
    document.title = `${title || companyStore.current.companyName} - 50skills`;
  }, [title, companyStore]);
}
